var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAustraliaFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    clipPath: "url(#clip0_2845_1650)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#012169"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9947 0.138667L8 6.1344L5.664 3.79733C4.99223 4.3676 4.36828 4.9919 3.7984 5.664L6.1344 8L0.138667 13.9947C0.0508452 14.6596 0.00453332 15.3293 0 16H1.8656L8 9.8656L14.1344 16H16V14.1344L9.8656 8L16 1.8656V0C15.3293 0.00453332 14.6596 0.0508452 13.9947 0.138667Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.60004 1.33984C8.46391 1.84062 7.39001 2.47208 6.40004 3.22144V5.33344H4.09818C2.70356 6.88694 1.62723 8.69893 0.930176 10.6668H6.40004V16.0001H9.60004V10.6668H16V5.33344H9.60004V1.33984Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C15.5573 0 15.1232 0.0309333 14.6891 0.0661333L7.37813 7.37813L4.68587 4.68587C4.47893 4.8992 4.29013 5.11893 4.09387 5.3376L7.37813 8.62187L0 16H1.24373L8.62187 8.62187L16 16V14.7552L8.62187 7.37813L16 0Z",
    fill: "#C8102E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96011 1.64917C8.29538 1.96876 7.65381 2.33445 7.04011 2.74357V6.4001H3.22144C2.47208 7.39007 1.84062 8.46397 1.33984 9.6001H7.04011V16.0001H8.96011V9.6001H16.0001V6.4001H8.96011V1.64917Z",
    fill: "#C8102E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4811 23.3068L9.4539 24.3308L9.25977 22.9324L10.6667 22.8097L9.45177 22.0886L10.2336 20.9132L8.9131 21.4124L8.4811 20.0684L8.04803 21.4124L6.7275 20.9132L7.50937 22.0886L6.29443 22.8097L7.70137 22.9324L7.5083 24.3308L8.4811 23.3068Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0337 15.9906L19.6513 16.6413L19.5287 15.7527L20.4225 15.6749L19.6513 15.2173L20.1473 14.4695L19.3089 14.7874L19.0337 13.9341L18.7596 14.7874L17.9201 14.4695L18.4172 15.2173L17.646 15.6749L18.5388 15.7527L18.4161 16.6413L19.0337 15.9906Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0181 10.591L24.6368 11.2406L24.513 10.3521L25.4069 10.2742L24.6357 9.81665L25.1317 9.06998L24.2933 9.38785L24.0181 8.53345L23.744 9.38785L22.9056 9.06998L23.4016 9.81665L22.6304 10.2742L23.5242 10.3521L23.4005 11.2406L24.0181 10.591Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4493 14.6614L29.0679 15.312L28.9442 14.4235L29.8381 14.3456L29.0669 13.888L29.5629 13.1403L28.7245 13.4582L28.4493 12.6038L28.1751 13.4582L27.3367 13.1403L27.8327 13.888L27.0615 14.3456L27.9554 14.4235L27.8317 15.312L28.4493 14.6614Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0181 23.8827L24.6368 24.5334L24.513 23.6448L25.4069 23.567L24.6357 23.1094L25.1317 22.3627L24.2933 22.6795L24.0181 21.8262L23.744 22.6795L22.9056 22.3627L23.4016 23.1094L22.6304 23.567L23.5242 23.6448L23.4005 24.5334L24.0181 23.8827Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0131 17.8038L26.5005 18.1067L26.364 17.5488L26.8024 17.1776L26.2296 17.136L26.0131 16.6038L25.7955 17.136L25.2227 17.1776L25.6621 17.5488L25.5245 18.1067L26.0131 17.8038Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2845_1650"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAustraliaFlag);
export default __webpack_public_path__ + "static/media/australia-flag.a89a8dab723f101e01ae272a3e0d7326.svg";
export { ForwardRef as ReactComponent };